import React from 'react'
import classNames from 'classnames'
import cls from './top-message-line.module.scss'
import { useMember } from '~src/new/app/providers/MemberProvider'
import { useAppFrame } from '~shared/components/AppFrameContext'

const PORTAL_WARNING_MESSAGE =
  'Уважаемые пользователи, раздел задания и раздел вознаграждения временно недоступны в связи с техническими работами на сайте. Приносим извинения за доставленные неудобства.'

const LOGIN_PAGE_COMPONENT_NAMES = ['LoginPage', 'LoginPageEmailaddress', 'LoginPageMobilephone']

export const TopMessageLine = ({ labels, className, contentComponentName }) => {
  const { member, isGuest, isArchiveAccount } = useMember()
  const { settings } = useAppFrame()
  const { isPortalWarningEnabled, portalWarningMessage } = settings?.general || {}
  const isLoginPage = LOGIN_PAGE_COMPONENT_NAMES.includes(contentComponentName)
  const isAuthorized = member && !isGuest

  if (isLoginPage) return null

  const memberMessage = isArchiveAccount
    ? labels?.ARCHIVE_ACCOUNT_NOTIFICATION
    : labels?.GUEST_USER_NOTIFICATION

  const messages = []

  if (isPortalWarningEnabled && isAuthorized) {
    messages.push({
      id: 'portal-warning',
      text: portalWarningMessage || labels?.PORTAL_WARNING_NOTIFICATION || PORTAL_WARNING_MESSAGE,
      className: cls.warning,
    })
  }

  if (isArchiveAccount || isGuest) {
    messages.push({
      id: 'member-status',
      text: memberMessage,
    })
  }

  if (messages.length === 0) return null

  return (
    <div className={cls.lineWrapper}>
      {messages.map(({ id, text, className: messageClassName }) => (
        <div key={id} className={classNames(cls.line, messageClassName, className)}>
          {text}
        </div>
      ))}
    </div>
  )
}
